import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    backend_url: "https://tickers.service.oboi.ru/",
  },
  mutations: {},
  actions: {},
  modules: {},
});
